import { useState, useEffect, useRef } from "react";
import { Link } from "@/components/common/Link";
export default function HeroSection() {
  const ref = useRef<HTMLElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) setVisible(true);
    }, {
      threshold: 0.1
    });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  return <section ref={ref} style={{
    backgroundPosition: "0% 0%",
    backgroundRepeat: "repeat",
    color: "rgb(26, 26, 26)",
    fontFamily: 'Inter, "Inter Fallback"',
    alignItems: "center",
    animation: "none 0s ease 0s 1 normal none running",
    display: "flex",
    position: "relative"
  }} className="w-full overflow-hidden min-h-[600px] md:min-h-[1080px] pt-10 pb-5 md:pt-[100px] md:pb-6">
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;700&family=Inter:wght@400;500;600;700&display=swap');`}</style>

      <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675284/img/image_a59f780d19.jpg" alt="Modern renovierte Wohnung in Köln mit Blick auf den Dom" className="w-full h-full object-cover" style={{
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      fontFamily: 'Inter, "Inter Fallback"',
      animation: "none 0s ease 0s 1 normal none running",
      position: "absolute",
      top: 0,
      left: 0,
      overflow: "clip",
      maxWidth: "100%"
    }} />

      <div className="absolute inset-0 pt-10 pb-[100px] md:pt-[200px] md:pb-[150px]" style={{
      backgroundImage: "linear-gradient(to right in oklab, rgba(26, 26, 26, 0.85) 0%, rgba(26, 26, 26, 0.3) 100%)",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      color: "rgb(26, 26, 26)",
      fontFamily: 'Inter, "Inter Fallback"',
      animation: "none 0s ease 0s 1 normal none running",
      position: "absolute"
    }} />

      <div className="page-container relative z-10 w-full">
        <div className={`flex flex-col items-start transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
        maxWidth: "520px"
      }}>
          <div className="mb-6" style={{
          display: "inline-flex",
          alignItems: "center",
          borderRadius: "9999px",
          border: "1px solid #C8A96E",
          padding: "6px 16px",
          backgroundColor: "transparent"
        }}>
            <span style={{
            color: "#C8A96E",
            fontFamily: 'Inter, "Inter Fallback"',
            fontSize: "13px",
            fontWeight: 400
          }}>
              Ihr Renovierungspartner in Köln
            </span>
          </div>

          <h1 style={{
          color: "rgb(255, 255, 255)",
          fontFamily: '"Playfair Display", "Playfair Display Fallback"',
          fontSize: "clamp(36px, 5vw, 60px)",
          fontWeight: "700",
          lineHeight: "1.25",
          border: "0px solid rgb(255, 255, 255)",
          animation: "none 0s ease 0s 1 normal none running",
          marginBottom: "clamp(12px, 3vw, 20px)"
        }}>
            Professionelle Renovierung &amp; Sanierung aus einer Hand
          </h1>

          <p style={{
          color: "rgba(255, 255, 255, 0.85)",
          fontFamily: 'Inter, "Inter Fallback"',
          fontSize: "18px",
          fontWeight: "400",
          lineHeight: "29.25px",
          border: "0px solid rgba(255,255,255,0.85)",
          animation: "none 0s ease 0s 1 normal none running",
          marginBottom: "clamp(20px, 4vw, 32px)",
          maxWidth: "430px"
        }}>
            Alt- und Neubaurenovierung, Umbau und Entrümpelung – zuverlässig,
            termingerecht und zu fairen Preisen. Seit Jahren Ihr Partner im Raum
            Köln.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 mb-3 sm:mb-5">
            <Link to="/ContactPage" style={{
            color: "rgb(255, 255, 255)",
            fontFamily: 'Inter, "Inter Fallback"',
            fontSize: "14px",
            fontWeight: "600",
            lineHeight: "20px",
            backgroundImage: "linear-gradient(to right in oklab, rgb(200, 169, 110) 0%, rgb(212, 188, 143) 100%)",
            borderRadius: "9999px",
            border: "0px solid rgb(255, 255, 255)",
            padding: "14px 32px",
            animation: "none 0s ease 0s 1 normal none running",
            textDecoration: "none",
            display: "inline-block",
            transition: "opacity 0.15s cubic-bezier(0.4, 0, 0.2, 1), transform 0.15s cubic-bezier(0.4, 0, 0.2, 1)",
            cursor: "pointer"
          }} onMouseEnter={e => {
            (e.currentTarget as HTMLAnchorElement).style.opacity = "0.9";
            (e.currentTarget as HTMLAnchorElement).style.transform = "scale(1.03)";
          }} onMouseLeave={e => {
            (e.currentTarget as HTMLAnchorElement).style.opacity = "1";
            (e.currentTarget as HTMLAnchorElement).style.transform = "scale(1)";
          }}>
              Kostenloses Angebot anfordern
            </Link>

            <Link to="/ServicesPage" style={{
            color: "rgb(255, 255, 255)",
            fontFamily: 'Inter, "Inter Fallback"',
            fontSize: "14px",
            fontWeight: "600",
            lineHeight: "20px",
            backgroundColor: "rgba(255, 255, 255, 0.05)",
            borderRadius: "9999px",
            border: "2px solid rgba(255, 255, 255, 0.8)",
            padding: "14px 32px",
            animation: "none 0s ease 0s 1 normal none running",
            textDecoration: "none",
            display: "inline-block",
            transition: "background-color 0.15s cubic-bezier(0.4, 0, 0.2, 1), transform 0.15s cubic-bezier(0.4, 0, 0.2, 1)",
            cursor: "pointer"
          }} onMouseEnter={e => {
            (e.currentTarget as HTMLAnchorElement).style.backgroundColor = "rgba(255, 255, 255, 0.12)";
            (e.currentTarget as HTMLAnchorElement).style.transform = "scale(1.03)";
          }} onMouseLeave={e => {
            (e.currentTarget as HTMLAnchorElement).style.backgroundColor = "rgba(255, 255, 255, 0.05)";
            (e.currentTarget as HTMLAnchorElement).style.transform = "scale(1)";
          }}>
              Unsere Leistungen
            </Link>
          </div>

          <div className="flex flex-wrap gap-6">
            {["Kostenlose Beratung", "Faire Preise", "Schnelle Umsetzung"].map(item => <span key={item} style={{
            color: "rgba(255, 255, 255, 0.85)",
            fontFamily: 'Inter, "Inter Fallback"',
            fontSize: "14px",
            fontWeight: 400,
            display: "flex",
            alignItems: "center",
            gap: "6px"
          }}>
                <span style={{
              color: "rgba(255, 255, 255, 0.85)"
            }}>&#10003;</span>
                {item}
              </span>)}
          </div>
        </div>
      </div>
    </section>;
}